export enum NeuroConstants {
  SET_HEADCONCIOUSNESS = 'neuro/SET_HEADCONCIOUSNESS',
  SET_STROKESCALE = 'neuro/SET_STROKESCALE',
  SET_STROKESCALEPNNV = 'neuro/SET_STROKESCALEPNNV',
  SET_STROKE_SCALE_ID = 'neuro/SET_STROKE_SCALE_ID',
  SET_STROKE_SCALE_SCORE = 'neuro/SET_STROKE_SCALE_SCORE',
  SET_STROKECVASYMPTOMSRESOLVED = 'neuro/SET_STROKECVASYMPTOMSRESOLVED',
  SET_STROKECVASYMPTOMSRESOLVEDPNNV = 'neuro/SET_STROKECVASYMPTOMSRESOLVEDPNNV',
  SET_THROMSCREEN = 'neuro/SET_THROMSCREEN',
  SET_THROMSCREENPNNV = 'neuro/SET_THROMSCREENPNNV',
  SET_HEADLOSSCONS = 'neuro/SET_HEADLOSSCONS',
  SET_HEADFINDINGS = 'neuro/SET_HEADFINDINGS',
  SET_CHEMPARALYZED = 'neuro/SET_CHEMPARALYZED',
  SET_DTBASELINESEEN = 'neuro/SET_DTBASELINESEEN',
  SET_DTBASELINESEENPNNV = 'neuro/SET_DTBASELINESEENPNNV',
  SAVE_DTBASELINESEEN = 'neuro/SAVE_DTBASELINESEEN',
  SAVE_NEURO = 'neuro/SAVE_NEURO',
  SET_RESPONSE = 'neuro/SET_RESPONSE',
  SET_NEURO = 'neuro/SET_NEURO',
  RESET_NEURO_STATE = 'neuro/RESET_NEURO_STATE',
  SET_MOTOR_SENSORY_VIA_CHEMPARALYZED = 'neuro/SET_MOTOR_SENSORY_VIA_CHEMPARALYZED',
  GET_NEURO = 'neuro/GET_NEURO',
  TOGGLE_WAS_PATIENT_IMMOBILIZED = 'neuro/TOGGLE_WAS_PATIENT_IMMOBILIZED',
  RESET_NEURO = 'neuro/RESET_NEURO',
}
